var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
const claim = namespace('claim');
const contract = namespace('contract');
let UserInformationCheckingQuestion = class UserInformationCheckingQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
        this.userInfo = {
            isClaimDateOk: null,
            isContactInfoOk: null,
            isEmailOk: null,
            isPhoneOk: null,
            isAddressOk: null,
        };
    }
    get extraData() {
        var _a;
        return ((_a = this.claimInfo) === null || _a === void 0 ? void 0 : _a.extraData) || {};
    }
    mounted() {
        const { isClaimDateOk = null, isContactInfoOk = null, isEmailOk = null, isPhoneOk = null, isAddressOk = null, } = this.extraData || {};
        this.userInfo = { isClaimDateOk, isContactInfoOk, isEmailOk, isPhoneOk, isAddressOk };
    }
    get userExtraDataStore() {
        var _a, _b, _c, _d, _e;
        return {
            isClaimDateOk: (_a = this.extraData.isClaimDateOk) !== null && _a !== void 0 ? _a : null,
            isContactInfoOk: (_b = this.extraData.isContactInfoOk) !== null && _b !== void 0 ? _b : null,
            isEmailOk: (_c = this.extraData.isEmailOk) !== null && _c !== void 0 ? _c : null,
            isPhoneOk: (_d = this.extraData.isPhoneOk) !== null && _d !== void 0 ? _d : null,
            isAddressOk: (_e = this.extraData.isAddressOk) !== null && _e !== void 0 ? _e : null,
        };
    }
    get contact() {
        var _a;
        return (((_a = this.selectedContract) === null || _a === void 0 ? void 0 : _a.contact) || {});
    }
    get fullName() {
        const firstName = this.contact.firstName || '';
        const lastName = this.contact.lastName || '';
        if (!firstName && !lastName) {
            return this.$tc('generic.unknown');
        }
        return `${firstName} ${lastName}`.trim();
    }
    get formattedClaimDate() {
        var _a;
        const damageDate = (_a = this.claimInfo) === null || _a === void 0 ? void 0 : _a.damageDate;
        if (!damageDate) {
            return this.$tc('generic.unknown');
        }
        try {
            const date = new Date(damageDate);
            return date.toLocaleDateString('fr-FR');
        }
        catch (_b) {
            return damageDate;
        }
    }
    get claimAddress() {
        const parts = [
            this.contact.address,
            this.contact.addressAffix,
            this.contact.zipcode,
            this.contact.city,
        ].filter(Boolean);
        return parts.join(' ') || this.$tc('generic.unknown');
    }
    get contactEmail() {
        return this.contact.email || this.$tc('generic.unknown');
    }
    get contactMobilePhone() {
        return this.contact.mobilePhone || this.$tc('generic.unknown');
    }
    get allInformationChecked() {
        // Utiliser userInfo pour l'activation du bouton (données locales)
        return [
            this.userInfo.isClaimDateOk,
            this.userInfo.isContactInfoOk,
            this.userInfo.isEmailOk,
            this.userInfo.isPhoneOk,
            this.userInfo.isAddressOk,
        ].every((value) => value !== null);
    }
    get answer() {
        // Utiliser userExtraDataStore pour l'affichage dans la sidebar (données du store)
        const allValidatedInStore = [
            this.userExtraDataStore.isClaimDateOk,
            this.userExtraDataStore.isContactInfoOk,
            this.userExtraDataStore.isEmailOk,
            this.userExtraDataStore.isPhoneOk,
            this.userExtraDataStore.isAddressOk,
        ].every((value) => value !== null);
        return allValidatedInStore
            ? this.$tc('claim.qualification.user_information_checking.information_verified')
            : null;
    }
    get panelTitle() {
        return this.$tc('claim.qualification.user_information_checking.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.user_information_checking.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get description() {
        return this.$tc('claim.qualification.user_information_checking.description');
    }
    get yesLabel() {
        const yesChoice = YES_OR_NO_CHOICES.find((choice) => choice.value === true);
        return yesChoice ? this.$tc(yesChoice.tradKey) : 'Oui';
    }
    get noLabel() {
        const noChoice = YES_OR_NO_CHOICES.find((choice) => choice.value === false);
        return noChoice ? this.$tc(noChoice.tradKey) : 'Non';
    }
    confirmInformation() {
        // Fusionner avec les extraData existantes pour ne pas perdre d'autres propriétés
        const mergedExtraData = {
            ...this.extraData,
            ...this.userInfo,
        };
        this.updateAndSaveClaim({
            claimPayload: {
                extraData: mergedExtraData,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], UserInformationCheckingQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claim')
], UserInformationCheckingQuestion.prototype, "claimInfo", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], UserInformationCheckingQuestion.prototype, "updateAndSaveClaim", void 0);
__decorate([
    contract.State('selectedContract')
], UserInformationCheckingQuestion.prototype, "selectedContract", void 0);
UserInformationCheckingQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiButton },
        props: QuestionProps,
    })
], UserInformationCheckingQuestion);
export default UserInformationCheckingQuestion;
